import { render, staticRenderFns } from "./ContactFormPcmania.vue?vue&type=template&id=7d85f186&scoped=true&"
import script from "./ContactFormPcmania.vue?vue&type=script&lang=js&"
export * from "./ContactFormPcmania.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormPcmania.vue?vue&type=style&index=0&id=7d85f186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85f186",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
